import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

export const sharedLinkEvent = (eventId: string) => {
  return HttpService.post(
    `${ApiService.icdc.module.event.sharedLink}?eventId=${eventId}`,
    {
      eventId
    }
  );
};

export const getEventQuota = async (events: any[])=> {
  let eventIds: number[] = []

  for (const event of events) {
    eventIds.push(parseInt(event.id))
  }

  let quotas = await HttpService.post(ApiService.beelajar.getEventQuota, { EventIds: eventIds.join(",") })

  let quotasData: any[] = quotas?.data;
  events = events.map(event => {
    const quota = quotasData.find(quota => quota.id === event.id);
    return {
      ...event,
      ...(quota ? { quotaavailable: quota.quotaavailable } : { quotaavailable: 0 })
    };
  });

  return events
}

export const getEventList = async ({
  page = 1,
  pageSize = 10,
  targetAudience = '',
  jobBand = '',
  category = '',
  datefrom = '',
  dateto = '',
  order = '',
  tag = '',
  name = '',
  searchkey = '',
  buCode = '',
  binusianId = ''
}: {
  page?: number;
  pageSize?: number;
  targetAudience?: string;
  jobBand?: string;
  category?: string;
  datefrom?: string;
  dateto?: string;
  order?: string;
  tag?: string;
  name?: string;
  searchkey?: string;
  buCode?: string;
  binusianId?: string;
}) => {
  const payload = {
    Category : category,
    Tag : tag,
    Datefrom : datefrom,  
    Dateto : dateto,
    Name : name,
    Order : order,
    Page : page,
    PageSize : pageSize,
    TargetAudience : targetAudience,
    SpesificJobBand : jobBand,
    SearchKey : searchkey,
    BuCode : buCode,
    BinusianId: binusianId
  }

  let events = await HttpService.post(ApiService.beelajar.getEventList, payload)

  try {
    events.data = await getEventQuota(events.data)
  } catch (e){
    console.error('Error on getting event quota, error detail:', e)
  }

  return events
};

export const getCategoryEvent = async () => {
  try {
    const response = await HttpService.get(ApiService.beelajar.getEventCategory);

    return response.data;
  } catch (error) {
    console.error('Error:', error.message);
    throw (
      error?.response?.data?.errorMessage ||
      'Something went wrong, please try again later.'
    );
  }
};

export const getTagEvent = async () => {
  try {
    var response = await HttpService.get(ApiService.beelajar.getEventTag)

    return response.data;
  } catch (error) {
    console.error('Error:', error.message);
    throw (
      error?.response?.data?.errorMessage ||
      'Something went wrong, please try again later.'
    );
  }
};

export const eventSelfRegiter = (data: any) => {
  return HttpService.post(ApiService.icdc.module.event.selfRegister, {
    ...data
  });
};

export const getAllEventIdAndNames = async () => {
  const request = await HttpService.get(ApiService.beelajar.getAllEventIdAndName);

  // @ts-ignore
  if(request.errorMessage){
    // @ts-ignore
    throw request.errorMessage;
  }

  return request.data;
}

export const getSyncHistory = async () => {
  const request = await HttpService.get(ApiService.icdc.module.event.getSyncHistory);

  // @ts-ignore
  if(request.errorMessage){
    // @ts-ignore
    throw request.errorMessage;
  }

  return request.data;
}

export const getSyncDetail = async (syncId: string) => {
  const request = await HttpService.get(`${ApiService.icdc.module.event.getSyncDetail}?syncId=${syncId}`);

  // @ts-ignore
  if(request.errorMessage){
    // @ts-ignore
    throw request.errorMessage;
  }

  return request.data;
}

export const getEventEnrollmentCount = async (eventId: string) => {
  const request = await HttpService.get(`${ApiService.icdc.module.event.getEventEnrollmentCount}?eventId=${eventId}`);

  // @ts-ignore
  if(request.errorMessage){
    // @ts-ignore
    throw request.errorMessage;
  }

  return request.data;
}

interface EventSynchronizationData {
  eventId: string;
  user: string;
}

export const postEventSynchronization = async (data: EventSynchronizationData) => {
  const request = await HttpService.post(`${ApiService.icdc.module.event.postSyncEnrollmentEvent}`, data);

  // @ts-ignore
  if(request.errorMessage){
    throw {
      // @ts-ignore
      errorMessage: request.errorMessage,
      // @ts-ignore
      stackTrace: request.stackTrace
    };
  }

  return request.data;
}

export const getDetailEvent = (
  courseId: string,
  emailLecturer: string,
  emailStaff: string,
  specificJobBand: string,
  targetAudience: string,
  businessUnitCode: string,
  binusianId: string
) => {
  const payload = {
    CourseId: courseId,
    EmailLecturer: emailLecturer,
    EmailStaff: emailStaff,
    SpecificJobBand: specificJobBand,
    TargetAudience: targetAudience,
    BuCode: businessUnitCode,
    BinusianId: binusianId
  }

  return HttpService.post(
    ApiService.beelajar.getEventDetail,
    payload
  )
};

export const getEventRegistrationStatusBatch = (
  courseIds: string[]
) => {
  const payload = {
    CourseIds: courseIds
  }

  return HttpService.post(
    ApiService.beelajar.getEventRegistrationStatus,
    payload
  )
};

export const likedEvent = (data: any) => {
  return HttpService.post(ApiService.icdc.module.event.likedEvent, {
    ...data
  });
};

export const likedDetail = (data: any) => {
  return HttpService.post(ApiService.icdc.module.event.likedDetail, {
    ...data
  });
};

export const getEventPreview = async ({
  page = 1,
  pageSize = 10,
  targetAudience = '',
  jobBand = '',
  category = '',
  datefrom = '',
  dateto = '',
  order = '',
  tag = '',
  name = '',
  searchkey = '',
  buCode = '',
  binusianId = ''
}: {
  page?: number;
  pageSize?: number;
  targetAudience?: string;
  jobBand?: string;
  category?: string;
  datefrom?: string;
  dateto?: string;
  order?: string;
  tag?: string;
  name?: string;
  searchkey?: string;
  buCode?: string;
  binusianId?: string;
}) => {
  const payload = {
    Category : category,
    Tag : tag,
    Datefrom : datefrom,  
    Dateto : dateto,
    Name : name,
    Order : order,
    Page : page,
    PageSize : pageSize,
    TargetAudience : targetAudience,
    SpesificJobBand : jobBand,
    SearchKey : searchkey,
    BuCode : buCode,
    BinusianId: binusianId
  }
  
  let events = await HttpService.post(ApiService.beelajar.getEventPreview, payload)

  try {
    events.data = await getEventQuota(events.data)
  } catch (e){
    console.error('Error on getting event quota, error detail:', e)
  }

  return events
};
